import 'zone.js'; // Required for Angular change detection (NG0908)
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';

bootstrapApplication(AppComponent, {
	providers: [
		provideHttpClient(withFetch()),
		provideRouter(routes)
	]
}).catch(err => console.error(err));


